'use strict';

var React = require('react');

var SvgBuyButtonVerticalLayoutMajor = function SvgBuyButtonVerticalLayoutMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3.5a1.75 1.75 0 0 0-1.75 1.75v1a.75.75 0 0 0 1.5 0v-1a.25.25 0 0 1 .25-.25h1a.75.75 0 0 0 0-1.5h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.25a1.75 1.75 0 0 0-1.75-1.75h-1a.75.75 0 0 0 0 1.5h1a.25.25 0 0 1 .25.25v1a.75.75 0 0 0 1.5 0v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.75a1.75 1.75 0 0 1-1.75 1.75h-1a.75.75 0 0 1 0-1.5h1a.25.25 0 0 0 .25-.25v-1a.75.75 0 0 1 1.5 0v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14.75c0 .966.784 1.75 1.75 1.75h1a.75.75 0 0 0 0-1.5h-1a.25.25 0 0 1-.25-.25v-1a.75.75 0 0 0-1.5 0v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.75a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 0-1.5 0v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 5.5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2Zm2 1.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 13a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
  }));
};
SvgBuyButtonVerticalLayoutMajor.displayName = "BuyButtonVerticalLayoutMajor";

exports.SvgBuyButtonVerticalLayoutMajor = SvgBuyButtonVerticalLayoutMajor;
